var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.68923 1.15819C4.09668 1.15819 1.18435 4.00621 1.18435 7.51941C1.18435 11.0326 4.09668 13.8806 7.68923 13.8806C11.2818 13.8806 14.1941 11.0326 14.1941 7.51941C14.1941 4.00621 11.2818 1.15819 7.68923 1.15819ZM0 7.51941C0 3.36655 3.44259 0 7.68923 0C11.9359 0 15.3785 3.36655 15.3785 7.51941C15.3785 11.6723 11.9359 15.0388 7.68923 15.0388C3.44259 15.0388 0 11.6723 0 7.51941Z",
    fill: "#7B7F91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2061 12.2978C12.4371 12.0714 12.812 12.0709 13.0436 12.2968L15.826 15.0107C16.0576 15.2366 16.0581 15.6032 15.8271 15.8297C15.5961 16.0561 15.2212 16.0566 14.9896 15.8307L12.2072 13.1168C11.9756 12.8909 11.9751 12.5243 12.2061 12.2978Z",
    fill: "#7B7F91"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.ccc00bf9d9f2bf79da306e7f6a36d40d.svg";
export { ForwardRef as ReactComponent };